import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api/index';
import { CREATE_POST_MALONE_PROJECT_WITH_ARTICLE_BRIEF_MUTATION } from './createPostMaloneProjectForArticleGroup.mutation';
import {
  CreatePostMaloneProjectWithArticleBriefMutation,
  CreatePostMaloneProjectWithArticleBriefMutationVariables
} from './__generated__/CreatePostMaloneProjectWithArticleBriefMutation';

type MutationProps = {
  onStart?: () => void;
  onCompleted?: () => void;
  onError?: (errors: string[]) => void;
};

export const useCreatePostMaloneProjectWithArticleBrief = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [createPostMalone] = useMutation<
    CreatePostMaloneProjectWithArticleBriefMutation,
    CreatePostMaloneProjectWithArticleBriefMutationVariables
  >(CREATE_POST_MALONE_PROJECT_WITH_ARTICLE_BRIEF_MUTATION, {
    client: kmsClient,
    onCompleted: (data) => {
      if (data.createPostMaloneProjectForArticleGroup?.errors?.length) {
        if (onError) onError(data.createPostMaloneProjectForArticleGroup.errors);
      } else {
        if (onCompleted) onCompleted();
      }
    },
    onError: (error) => onError && onError([error.message])
  });
  return (variables: CreatePostMaloneProjectWithArticleBriefMutationVariables) => {
    if (onStart) onStart();
    createPostMalone({ variables });
  };
};
